module.exports = __webpack_public_path__ + "static/media/tip2.a5cd7c29.svg";